export default __webpack_public_path__ + "static/media/bo_4.ea6c6eb7.mp3";